<template>
  <div :style="style" class="flex cursor-pointer" @click="onInput(true)">
    <svg-plus-circle width="26" height="23" class="mr-2" :fill="style['--primary-color']"></svg-plus-circle>
    <h3 class="w-full text-lg font-bold mb-2">Add Secondary Insurance</h3>
  </div>
</template>

<script>
import SvgPlusCircle from "@/components/Svg/SvgPlusCircle";
export default {
    components: {
    SvgPlusCircle,
  },
  props: ["value"],
  data() {
    return {
      internalValue: true,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
  computed: {
    style() {
      return {
        "--primary-color":
          this.$store.state.config.colors.primaryColor ||
          "#51B44F",
      };
    },
  }
};
</script>

<style scoped>
h3{
  color: var(--primary-color);
}
</style>